import React, { useState, useEffect } from 'react';
import { useHistory, useRouteMatch, Switch, Route, useLocation } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Heading, Row, Col, PageContent, CisContainer } from 'components';
import { useTranslation } from 'react-i18next';
import StatisticsSelect from './StatisticsSelect';
import Certificates from '../Certificates/Certificates';
import Forecasts from '../Forecasts/Forecasts';
import CertificateHolders from '../CertificateHolders/CertificateHolders';

const Statistics = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const match = useRouteMatch();
  const location = useLocation();
  const [portalReady, setPortalReady] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const options = [
    { value: 'certificates', label: t('page.user.cis.statistics.certificates') },
    { value: 'certificate-holders', label: t('page.user.cis.statistics.certificateHolders') },
    { value: 'forecasts', label: t('page.user.cis.statistics.forecasts') },
  ];

  const optionValues = options.map(opt => opt.value).join('|');

  useEffect(() => {
    if (document.getElementById('ipma-cis-cvmb-statistics-dropdown-portal')) {
      setPortalReady(true);
    }
  }, []);

  useEffect(() => {
    const matchOption = location.pathname.split('/').pop();
    const found = options.find(opt => opt.value === matchOption) || null;
    if (
      (found && (!selectedOption || found.value !== selectedOption.value)) ||
      (!found && selectedOption)
    ) {
      setSelectedOption(found);
    }
  }, [location.pathname, options, selectedOption]);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (option) {
      history.push(`${match.url.replace(/\/$/, '')}/${option.value}`);
    } else {
      history.push(match.url.replace(new RegExp(`\/(${optionValues})$`), ''));
    }
  };

  return (
    <PageContent>
      <CisContainer>
        <Switch>
          <Route exact path={match.path}>
            <Heading as="h3" size="h5">{t('page.user.cis.statistics.selectStatisticsTitle')}</Heading>
          </Route>
          <Route path={`${match.path}/certificates`} component={Certificates} />
          <Route path={`${match.path}/certificate-holders`} component={CertificateHolders} />
          <Route path={`${match.path}/forecasts`} component={Forecasts} />
        </Switch>
      </CisContainer>
      {portalReady &&
        ReactDOM.createPortal(
          <StatisticsSelect
            options={options}
            value={selectedOption}
            onChange={handleChange}
            placeholder={t('page.user.cis.statistics.selectStatisticsPlaceholder')}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isClearable={true}
          />,
          document.getElementById('ipma-cis-cvmb-statistics-dropdown-portal')
        )}
    </PageContent>
  );
};

export default Statistics;
